/*
 * @Author: zyy
 * @Date: 2022-12-01 14:26:38
 * @LastEditors: zyy
 * @LastEditTime: 2022-12-01 15:02:55
 * @Description: default
 */
import Axios from 'axios';
import Qs from 'qs';

export default {

  // 缴费记录分页列表
  list(
    community_id,
    car_no,
    start_time,
    end_time,
    page,
    per_page
  ) {
    return Axios.get('/ltjf/api/admin/car/access/record', {
      params: {
        community_id,
        car_no,
        start_time,
        end_time,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },
  info(data) {
    return Axios.get(`/ltjf/api/admin/car/access/record/pic`, {
      params: data,
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  }




}